import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';

export default class FooterItems extends Controls {
    namespace = 'footerItems';

    get hasPinnedParticipant() {
        const { wizyPinnedParticipant } = APP.store.getState()['wizyconf/large-video'];

        return wizyPinnedParticipant;
    }

    constructor() {
        super();
        this._items = [];
        this.indexPinButton = null;
        this.collectElements();
    }

    collectElements() {
        this._items = [];
        const elements = document.querySelectorAll('.toolbox-button');

        elements.forEach((elem, index) => {
            if (elem.closest('.wizyconf-unpin-button')) {
                this.indexPinButton = index;
            }
            this._items.push(
                new KeyboardFocusable(elem)
            );
        });
    }

    focus(idx) {
        if (typeof idx === 'number') {
            this._currentIndex = idx;
        } else {
            if (this.indexPinButton === this._items.length - 1) {
                if (this.hasPinnedParticipant) {
                    this._currentIndex = this._items.length - 1;
                } else {
                    this._currentIndex = this._items.length - 2;
                }
            } else {
                this._currentIndex = this._items.length - 1;
            }
        }

        if (this._items[this._currentIndex]) {
            this._items[this._currentIndex].focus();
        }
    }

    isPossibleUp() {
        return false;
    }

    isPossibleDown() {
        return false;
    }

    isPossiblePrev() {
        return this._currentIndex !== 0;
    }

    isPossibleNext() {
        let lengthArray = this._items.length - 1;

        if (this.isPinnedButtonSelected('next')) {
            lengthArray = this._items.length - 2;
        }

        return this._currentIndex !== lengthArray;
    }

    isPinnedButtonSelected(direction) {
        let index = this._currentIndex;

        if (this.hasPinnedParticipant) {
            return false;
        }
        if (direction === 'next') {
            ++index;
        } else {
            --index;
        }

        return this.indexPinButton === index;
    }

    next() {
        if (this.isPossibleNext()) {
            this.unfocus();
            if (this.isPinnedButtonSelected('next')) {
                this._currentIndex++;
            }
            super.down();
        }
    }

    prev() {
        if (this.isPossiblePrev()) {
            this.unfocus();
            if (this.isPinnedButtonSelected('prev')) {
                this._currentIndex--;
            }
            super.up();
        }

    }
}
